import { Component } from '@angular/core';
import { Survey } from '../../../models/survey.model';
import { SurveyService } from '../../../services/survey.service';
import { ActivatedRoute } from '@angular/router';
import { Question } from '../../../models/question.model';
import { QuestionService } from '../../../services/question.service';
import { QuestionModalComponent } from '../../../components/question-modal/question-modal.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AnswerItem } from '../../../models/answer-item.model';
import { AnswerItemService } from '../../../services/answer-item.service';
import { AnswerItemModalComponent } from '../../../components/answer-item-modal/answer-item-modal.component';
import { ImageService } from '../../../services/image.service';

@Component({
  selector: 'app-survey-page',
  templateUrl: './survey-page.component.html',
  styleUrl: './survey-page.component.scss'
})
export class SurveyPageComponent {

  public neighborhoodId: string = '';
  public surveyId: string = '';
  public survey: Survey | null = null;

  constructor(
    private activatedRoute: ActivatedRoute,
    public answerItemService: AnswerItemService,
    private imageService: ImageService,
    private modalService: NgbModal,
    private questionService: QuestionService,
    private surveyService: SurveyService,
  ) { 

    this.activatedRoute.params.subscribe(
      async params => {

        // console.log(params);
        this.neighborhoodId = params['neighborhoodId'];
        this.surveyId = params['surveyId'];

        this.getData();

      }
    );

  }

  /*
   ██████╗ ██████╗ ███╗   ███╗██████╗ ██████╗ ███████╗███████╗███████╗███████╗██╗██╗     ███████╗
  ██╔════╝██╔═══██╗████╗ ████║██╔══██╗██╔══██╗██╔════╝██╔════╝██╔════╝██╔════╝██║██║     ██╔════╝
  ██║     ██║   ██║██╔████╔██║██████╔╝██████╔╝█████╗  ███████╗███████╗█████╗  ██║██║     █████╗
  ██║     ██║   ██║██║╚██╔╝██║██╔═══╝ ██╔══██╗██╔══╝  ╚════██║╚════██║██╔══╝  ██║██║     ██╔══╝
  ╚██████╗╚██████╔╝██║ ╚═╝ ██║██║     ██║  ██║███████╗███████║███████║██║     ██║███████╗███████╗
   ╚═════╝ ╚═════╝ ╚═╝     ╚═╝╚═╝     ╚═╝  ╚═╝╚══════╝╚══════╝╚══════╝╚═╝     ╚═╝╚══════╝╚══════╝

  */
   async compressFile() {

    const images = await this.imageService.compressFile();
 
    for(let i = 0; i < images.length; i++) {

      const image = images[i];

      let fileCategory = 'image';

      if(image.startsWith('data:application/pdf')) {
        fileCategory = 'pdf';
      }

      const result = await this.surveyService.uploadFile(
        this.survey!,
        image,
        fileCategory,
        fileCategory === 'pdf' ? `Documento PDF ${i + 1}` : `Foto ${i + 1}`,
        {
          index: i + 1,
          total: images.length
        }
      );

      console.log(result);

    }

    await this.getData();
    
  }

  /*
  ██████╗ ███████╗██╗     ███████╗████████╗███████╗
  ██╔══██╗██╔════╝██║     ██╔════╝╚══██╔══╝██╔════╝
  ██║  ██║█████╗  ██║     █████╗     ██║   █████╗
  ██║  ██║██╔══╝  ██║     ██╔══╝     ██║   ██╔══╝
  ██████╔╝███████╗███████╗███████╗   ██║   ███████╗
  ╚═════╝ ╚══════╝╚══════╝╚══════╝   ╚═╝   ╚══════╝

  */
  async delete(
    question: Question
  ) {
    const flag = confirm(`¿Está seguro que desea borrar la pregunta "${question.question}"?`);

    if (flag) {
      const secondaFlag = await this.questionService.delete(
        this.survey!,
        question
      );

      if(secondaFlag) {
        this.getData();
      }
    }
  }

  /*
   ██████╗ ██████╗ ███████╗███╗   ██╗
  ██╔═══██╗██╔══██╗██╔════╝████╗  ██║
  ██║   ██║██████╔╝█████╗  ██╔██╗ ██║
  ██║   ██║██╔═══╝ ██╔══╝  ██║╚██╗██║
  ╚██████╔╝██║     ███████╗██║ ╚████║
   ╚═════╝ ╚═╝     ╚══════╝╚═╝  ╚═══╝

  */
  open(
    question?: Question
  ) {
    const modalRef = this.modalService.open(
      QuestionModalComponent
    );

    modalRef.componentInstance.survey = this.survey;
    modalRef.componentInstance.question = question;

    modalRef.closed.subscribe(
      async () => {
    
        this.getData();

      }
    );
  }

  /*
   ██████╗ ███████╗████████╗██████╗  █████╗ ████████╗ █████╗
  ██╔════╝ ██╔════╝╚══██╔══╝██╔══██╗██╔══██╗╚══██╔══╝██╔══██╗
  ██║  ███╗█████╗     ██║   ██║  ██║███████║   ██║   ███████║
  ██║   ██║██╔══╝     ██║   ██║  ██║██╔══██║   ██║   ██╔══██║
  ╚██████╔╝███████╗   ██║   ██████╔╝██║  ██║   ██║   ██║  ██║
   ╚═════╝ ╚══════╝   ╚═╝   ╚═════╝ ╚═╝  ╚═╝   ╚═╝   ╚═╝  ╚═╝

  */
  async getData() {

    this.survey = await this.surveyService.get(
      this.neighborhoodId, 
      this.surveyId
    );

  }

  /*
  ██████╗ ███████╗██╗     ███████╗████████╗███████╗ █████╗ ███╗   ██╗███████╗██╗    ██╗███████╗██████╗ ██╗████████╗███████╗███╗   ███╗
  ██╔══██╗██╔════╝██║     ██╔════╝╚══██╔══╝██╔════╝██╔══██╗████╗  ██║██╔════╝██║    ██║██╔════╝██╔══██╗██║╚══██╔══╝██╔════╝████╗ ████║
  ██║  ██║█████╗  ██║     █████╗     ██║   █████╗  ███████║██╔██╗ ██║███████╗██║ █╗ ██║█████╗  ██████╔╝██║   ██║   █████╗  ██╔████╔██║
  ██║  ██║██╔══╝  ██║     ██╔══╝     ██║   ██╔══╝  ██╔══██║██║╚██╗██║╚════██║██║███╗██║██╔══╝  ██╔══██╗██║   ██║   ██╔══╝  ██║╚██╔╝██║
  ██████╔╝███████╗███████╗███████╗   ██║   ███████╗██║  ██║██║ ╚████║███████║╚███╔███╔╝███████╗██║  ██║██║   ██║   ███████╗██║ ╚═╝ ██║
  ╚═════╝ ╚══════╝╚══════╝╚══════╝   ╚═╝   ╚══════╝╚═╝  ╚═╝╚═╝  ╚═══╝╚══════╝ ╚══╝╚══╝ ╚══════╝╚═╝  ╚═╝╚═╝   ╚═╝   ╚══════╝╚═╝     ╚═╝

  */
  async deleteAnswerItem(
    question: Question,
    answerItem: AnswerItem
  ) {
    const flag = confirm(`¿Está seguro que desea borrar la respuesta "${answerItem.answer}"?`);

    if (flag) {
      const secondFlag = await this.answerItemService.delete(
        this.survey!,
        question,
        answerItem
      );

      if(secondFlag) {
        this.getData();
      }
    }
  }

  /*
   ██████╗ ██████╗ ███████╗███╗   ██╗ █████╗ ███╗   ██╗███████╗██╗    ██╗███████╗██████╗ ██╗████████╗███████╗███╗   ███╗
  ██╔═══██╗██╔══██╗██╔════╝████╗  ██║██╔══██╗████╗  ██║██╔════╝██║    ██║██╔════╝██╔══██╗██║╚══██╔══╝██╔════╝████╗ ████║
  ██║   ██║██████╔╝█████╗  ██╔██╗ ██║███████║██╔██╗ ██║███████╗██║ █╗ ██║█████╗  ██████╔╝██║   ██║   █████╗  ██╔████╔██║
  ██║   ██║██╔═══╝ ██╔══╝  ██║╚██╗██║██╔══██║██║╚██╗██║╚════██║██║███╗██║██╔══╝  ██╔══██╗██║   ██║   ██╔══╝  ██║╚██╔╝██║
  ╚██████╔╝██║     ███████╗██║ ╚████║██║  ██║██║ ╚████║███████║╚███╔███╔╝███████╗██║  ██║██║   ██║   ███████╗██║ ╚═╝ ██║
   ╚═════╝ ╚═╝     ╚══════╝╚═╝  ╚═══╝╚═╝  ╚═╝╚═╝  ╚═══╝╚══════╝ ╚══╝╚══╝ ╚══════╝╚═╝  ╚═╝╚═╝   ╚═╝   ╚══════╝╚═╝     ╚═╝

  */
  openAnswerItem(
    question: Question,
    answerItem?: AnswerItem
  ) {
    const modalRef = this.modalService.open(
      AnswerItemModalComponent
    );

    modalRef.componentInstance.survey = this.survey;
    modalRef.componentInstance.question = question;
    modalRef.componentInstance.answerItem = answerItem;

    modalRef.closed.subscribe(
      async () => {
    
        this.getData();

      }
    );
  }

  /*
  ███████╗███████╗██╗     ███████╗ ██████╗████████╗██████╗ ██████╗ ███████╗███████╗██╗██╗     ███████╗
  ██╔════╝██╔════╝██║     ██╔════╝██╔════╝╚══██╔══╝██╔══██╗██╔══██╗██╔════╝██╔════╝██║██║     ██╔════╝
  ███████╗█████╗  ██║     █████╗  ██║        ██║   ██████╔╝██║  ██║█████╗  █████╗  ██║██║     █████╗
  ╚════██║██╔══╝  ██║     ██╔══╝  ██║        ██║   ██╔═══╝ ██║  ██║██╔══╝  ██╔══╝  ██║██║     ██╔══╝
  ███████║███████╗███████╗███████╗╚██████╗   ██║   ██║     ██████╔╝██║     ██║     ██║███████╗███████╗
  ╚══════╝╚══════╝╚══════╝╚══════╝ ╚═════╝   ╚═╝   ╚═╝     ╚═════╝ ╚═╝     ╚═╝     ╚═╝╚══════╝╚══════╝

  */
  selectPdfFile() {
    const fileInput = document.createElement('input');
    fileInput.type = 'file';
    fileInput.accept = 'application/pdf';
    fileInput.style.display = 'none';

    fileInput.addEventListener('change', (event: any) => {
      const file: File = event.target.files[0];

      if (!file) {
        return;
      }

      if (file.type !== 'application/pdf') {
        alert('Por favor selecciona un archivo PDF válido.');
        return;
      }

      if (file.size > 6 * 1024 * 1024) { // 6MB
        alert('El archivo debe ser menor a 6MB.');
        return;
      }

      const reader = new FileReader();
      reader.onload = async () => {
        const selectedPdfBase64 = reader.result as string;
        console.log('Archivo PDF en base64:', selectedPdfBase64);

        const result = await this.surveyService.uploadFile(
          this.survey!,
          selectedPdfBase64,
          'pdf',
          file.name
        );

        await this.getData();

      };
      reader.readAsDataURL(file);
    });

    // Dispara el diálogo de selección
    fileInput.click();
  }

}
